// Phone display helper. Preserves the user's typing for international and
// already-formatted inputs; progressively US-formats plain digit entry:
//   '5'                       → '5'
//   '5551'                    → '(555) 1'
//   '5551234567'              → '(555) 123-4567'
//   '+44 20 7946 0958'        → '+44 20 7946 0958'  (preserved)
//   '+1 (555) 123-4567'       → '+1 (555) 123-4567' (preserved)
//   '555.123.4567'            → '(555) 123-4567'    (US digits → reformatted)
//
// Anything containing a leading '+' (international / explicit country code)
// or more than 10 digits is treated as already-formatted by the user and
// returned verbatim. Otherwise, digits are extracted and US-formatted.
// See PreConference_Audit.md B6 — the prior version aggressively truncated
// international numbers to their first 10 digits in US format.
export const formatPhone = (val) => {
  if (val === null || val === undefined) return ''
  const raw = String(val)
  if (!raw) return ''
  const digits = raw.replace(/\D/g, '')
  // International / explicit-country-code / longer-than-NANP entry: preserve
  // the user's typing verbatim so we don't mangle the meaningful prefix.
  if (raw.includes('+') || digits.length > 10) return raw
  // US progressive format for 1–10 digit entry.
  const trimmed = digits.slice(0, 10)
  if (trimmed.length === 0) return raw.trim() ? raw : ''
  if (trimmed.length <= 3) return trimmed
  if (trimmed.length <= 6) return `(${trimmed.slice(0,3)}) ${trimmed.slice(3)}`
  return `(${trimmed.slice(0,3)}) ${trimmed.slice(3,6)}-${trimmed.slice(6)}`
}
